import { getContrastColor } from "@lib/helpers/ColorHelper";
import { Tag, type TagProps } from "antd";
import styled from "styled-components";

const StyledAppTag = styled(Tag)`
  color: ${({ color }) => getContrastColor(color)} !important;
  background-color: ${({ color }) => color} !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  svg,
  span,
  small,
  .ant-typography {
    color: ${({ color }) => getContrastColor(color)} !important;
  }
`;

export default function AppTag(props: TagProps) {
  const { children, ...rest } = props;
  return <StyledAppTag {...rest}>{children}</StyledAppTag>;
}
